$('.teaser--assortment')
	.not('.teaser--assortment.active')
	.click(function (e) {
		//e.preventDefault();
		$('.teaser--assortment.active').removeClass('active')
		$(this).addClass('active')

		$('.icon--plus', this).addClass('close')
	})

$('.teaser--assortment').on('click', ' .icon--plus.close', function (e) {
	$(this).parent().removeClass('active')
	return false
})

$('.teaser').each(function () {
	var slidesLength = $('.teaser__image img', this).length
	$(this).addClass('teaser--with-' + slidesLength)
})

// Videowall
document.addEventListener('DOMContentLoaded', () => {
	const container = document.querySelector('.tx-jobapplications .section__container')
	if (!container) return

	// Stagger-Index für Teaser 7–12 setzen: --i = 0..5
	const nextSix = Array.from(container.querySelectorAll('.teaser:nth-child(n+8):nth-child(-n+12)'))
	nextSix.forEach((el, idx) => el.style.setProperty('--i', idx))

	// Start, sobald Container sichtbar ist (robuster als fixer Timer im Offscreen)
	const io = new IntersectionObserver(
		entries => {
			if (entries.some(e => e.isIntersecting)) {
				setTimeout(() => {
					container.dataset.phase = '2'
				}, 3000) // 3s Test, später 10000
				io.disconnect()
			}
		},
		{ threshold: 0.2 }
	)

	io.observe(container)
})
